var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background': _vm.colors[_vm.colorIndex], 'width': (_vm.width + "%")}),attrs:{"id":"strength"}})}
var staticRenderFns = []

export { render, staticRenderFns }